// extracted by mini-css-extract-plugin
export default {"toggleButton":"Toggle_toggleButton__kxWxq","buttonWrapper":"Toggle_buttonWrapper__by9RZ"};